<!-- Spacer -->
<div class="expepharma-vertical-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>
